export const DEFINE_MODULE = {
  name: "phân môn giảng dạy",
  fields: "teacherRoles"
}
